import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div``;

export const SelectWrapper = styled.div`
  position: relative;
`;

export const Select = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  width: 100%;
  height: 38px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  ${({ disabled, theme }) => disabled && `background-color: ${theme.colors.grey001}`};
`;

export const TextInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  align-items: center;
  background-color: rgb(241, 244, 246);
  border-radius: 4px;
  width: 100%;
`;

export const TextInput = styled.input`
  height: 36px;
  font-size: 13px;
  line-height: 20px;
  color: rgb(126, 126, 126);
  background-color: rgb(241, 244, 246);
  border: none;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
`;

export const Icon = styled.div`
  padding: 0 10px;
  &:before {
    content: ${({ icon }) => icon};
    font-family: Icomoon;
    font-size: 12px;
  }
`;

export const EnvelopWrapper = styled.div`
  position: absolute;
  top: 46px;
  width: 100%;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgb(0 0 0 / 16%);
  z-index: 2;
`;

export const Envelop = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: 230px;
  padding: 4px 0;
  overflow-y: scroll;
`;

export const EnvelopItem = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 6px 16px;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey100};
  }
`;

export const FilterDropDownCheckbox = styled.input`
  margin-right: 10px;
  cursor: inherit;
`;

export const FitlerActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 10px;
  border-top: 1px solid lightgrey;
`;

export const FitlerActionBtn = styled.button`
  text-align: center;
  cursor: pointer;
  min-width: 96px;
  height: 28px;
  background: rgb(241, 244, 246);
  color: rgb(71, 71, 71);
  border: 1px solid rgb(215, 220, 227);
  box-sizing: border-box;
  border-radius: 4px;
`;
